import { BaseEnum } from "./baseEnum";

const listApplicationTypeEnum: Array<ApplicationTypeEnum> = [];

export type ApplicationType = "Global" | "Specific";

export class ApplicationTypeEnum extends BaseEnum {
	static Global = new ApplicationTypeEnum(
		1,
		"Global",
		"Global",
		"globe"
	);
	static Specific = new ApplicationTypeEnum(
		2,
		"Specific",
		"Específico",
		"target"
	);

	constructor(
		public id: number,
		public value: string,
		public label: string,
		icon: string
	) {
		super(id, value, label, icon);
		listApplicationTypeEnum.push(this);
	}

	public static buildListEnum(): Array<BaseEnum> {
		return listApplicationTypeEnum;
	}
}